import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import './HomePage.css';

const HomePage = () => {
  const [totalLevels, setTotalLevels] = useState(0);
  const [chapters, setChapters] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      const snap = await getDocs(collection(db, 'levels'));
      setTotalLevels(snap.size);
      const chapterSet = new Set(snap.docs.map((d) => d.data().chapter).filter(Boolean));
      setChapters(chapterSet.size);
      setLoading(false);
    };
    fetchMetrics();
  }, []);

  if (loading) {
    return <div className="page-content">Loading metrics...</div>;
  }

  return (
    <div className="page-content">
      <h1>Dashboard</h1>
      <div className="metrics-container">
        <div className="metric-card">
          <h2>Total Levels</h2>
          <p>{totalLevels}</p>
        </div>
        <div className="metric-card">
          <h2>Chapters</h2>
          <p>{chapters}</p>
        </div>
      </div>
      <div className="card">
        <h2>Bắt đầu</h2>
        <p>Vào <a href="/levels">Game Levels</a> để thiết kế/import/export level. Nếu Firestore chưa có level nào, dùng nút "Import seed levels" ở trang đó để nạp 30 level campaign hiện có.</p>
      </div>
    </div>
  );
};

export default HomePage;
